<nav [attr.aria-label]="'ARIA_LABEL.TABS' | translate ">
    <sis-tab-content-switch [wide]="'sm'"
                            [tabs]="tabs"
                            [currentIndex]="currentTabIndex"
                            (currentIndexChange)="onTabClick($event)">
    </sis-tab-content-switch>
</nav>
